const transactions = ["Deposit", "Withdrawal"];
export default transactions;